import { render, staticRenderFns } from "./elCardShow2.vue?vue&type=template&id=1406fcd8&scoped=true"
import script from "./elCardShow2.vue?vue&type=script&lang=js"
export * from "./elCardShow2.vue?vue&type=script&lang=js"
import style0 from "./elCardShow2.vue?vue&type=style&index=0&id=1406fcd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1406fcd8",
  null
  
)

export default component.exports